import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/transporte/trasolicitacaopasseturma',
    name: 'trasolicitacaopasseturma',
    description: 'Solicitação e Passe por Turma',
    component: () => import('@/views/transporte/trasolicitacaopasseturma/Index.vue'),
    meta: { permissions: [eTipoPermissao.SOLICITACAOEPASSETURMANOVO_MENU_1100100198] },
    goesToMenu: true,
  },
];
